/* ===================================================
   UNCUT — Daily Face Oil
   Theme JavaScript
   =================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* Keep the Real Results film moving in storefront and theme preview. */
  document.querySelectorAll('.vi-autoplay-video').forEach(function (video) {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    var startVideo = function () {
      var playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') playAttempt.catch(function () {});
    };
    startVideo();
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) startVideo();
    });
  });

  /* ─── SCROLL REVEAL ─── */
  const io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('on');
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.rv').forEach(function (el) {
    io.observe(el);
  });

  /* ─── NAV SCROLL BORDER ─── */
  var nav = document.getElementById('uncut-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.style.borderBottom = window.scrollY > 50
        ? '1px solid rgba(156,123,82,0.18)'
        : '1px solid rgba(255,255,255,0.05)';
    });
  }

});

/* ─── EMAIL SUBMIT ─── */
function uncutSubmit(inputId) {
  var input = document.getElementById(inputId);
  if (!input) return;
  var email = input.value.trim();
  var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    input.style.borderColor = '#c0392b';
    input.placeholder = 'Please enter a valid email';
    setTimeout(function () {
      input.style.borderColor = '';
      input.placeholder = 'Enter your email';
    }, 2500);
    return;
  }

  /* Replace the button with a success message */
  var btn = input.nextElementSibling;
  if (btn) {
    btn.textContent = 'You\'re In ✓';
    btn.style.background = '#2a4a2a';
    btn.style.letterSpacing = '2px';
    btn.disabled = true;
  }
  input.value = '';
  input.placeholder = 'Welcome to the standard.';
  input.disabled = true;

  /*
    TO CONNECT TO KLAVIYO / MAILCHIMP / SHOPIFY CUSTOMERS:
    Replace this block with your actual form submit / API call.

    Example Klaviyo:
    fetch('https://a.klaviyo.com/client/subscriptions/', {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'revision': '2023-02-22' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            list_id: 'YOUR_LIST_ID',
            email: email
          }
        }
      })
    });
  */
}

/* ─── VIDEO MODAL ─── */
function uncutPlayVideo(url) {
  var modal = document.getElementById('video-modal');
  var frame = document.getElementById('video-frame');
  if (!modal || !frame) return;

  /* Auto-add autoplay to embed URL */
  var embedUrl = url.includes('?') ? url + '&autoplay=1' : url + '?autoplay=1';
  frame.src = embedUrl;
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function uncutCloseVideo() {
  var modal = document.getElementById('video-modal');
  var frame = document.getElementById('video-frame');
  if (!modal || !frame) return;

  frame.src = '';
  modal.style.display = 'none';
  document.body.style.overflow = '';
}

/* Close modal on backdrop click */
document.addEventListener('click', function (e) {
  var modal = document.getElementById('video-modal');
  if (modal && e.target === modal) uncutCloseVideo();
});

/* Close modal on Escape key */
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') uncutCloseVideo();
});
